import { Link, useLocation } from "react-router-dom";
import "./MainNav.scss";
import { ChevronIcon } from "../assets/global/Icons";
import { SERVICES_ENABLED } from "../common/constants";

function MainNav() {
  const location = useLocation();

  return (
    <nav className="main-nav">
      <ul className="main-nav__list">
        <li>
          <Link
            to="/"
            className={`main-nav__link ${location.pathname === "/" ? "active" : ""}`}
          >
            home
          </Link>
        </li>
        <li id="menu-nav">
          <Link
            to="/menu"
            className={`main-nav__link ${location.pathname === "/menu" ? "active" : ""}`}
          >
            menu
            <ChevronIcon
              className="chevron-icon"
              role="button"
              aria-label="View menu selections"
              tabIndex={0}
            />
          </Link>
          <ul className="dropdown-nav" id="menu-nav__dropdown">
            <li>
              <Link
                to="/menu/cakes"
                className="dropdown-nav__link"
                tabIndex={-1}
              >
                cakes
              </Link>
            </li>
            <li>
              <Link
                to="/menu/cupcakes"
                className="dropdown-nav__link"
                tabIndex={-1}
              >
                cupcakes
              </Link>
            </li>
            <li>
              <Link
                to="/menu/cookies"
                className="dropdown-nav__link"
                tabIndex={-1}
              >
                cookies
              </Link>
            </li>
            <li>
              <Link
                to="/menu/cakesicles"
                className="dropdown-nav__link"
                tabIndex={-1}
              >
                cakesicles
              </Link>
            </li>
            <li>
              <Link
                to="/menu/tarts-bars-brownies"
                className="dropdown-nav__link"
                tabIndex={-1}
              >
                tarts, bars, brownies
              </Link>
            </li>
          </ul>
        </li>
        {SERVICES_ENABLED && (
          <li id="services-nav">
            <Link
              to="/services"
              className={`main-nav__link ${location.pathname === "/services" ? "active" : ""}`}
            >
              services
              <ChevronIcon
                className="chevron-icon"
                role="button"
                aria-label="View services selections"
                tabIndex={0}
              />
            </Link>
            <ul className="dropdown-nav" id="services-nav__dropdown">
              <li>
                <Link to="/services/private-events" className="dropdown-nav__link" tabIndex={-1}>
                  private events
                </Link>
              </li>
              <li>
                <Link to="/services/corporate-events" className="dropdown-nav__link" tabIndex={-1}>
                  corporate events
                </Link>
              </li>
              <li>
                <Link to="/services/weddings" className="dropdown-nav__link" tabIndex={-1}>
                  weddings
                </Link>
              </li>
              <li>
                <Link to="/services/holiday-orders" className="dropdown-nav__link" tabIndex={-1}>
                  holiday orders
                </Link>
              </li>
              <li>
                <Link to="/services/equipment-rental" className="dropdown-nav__link" tabIndex={-1}>
                  equipment rental
                </Link>
              </li>
            </ul>
          </li>
        )}
        <li>
          <Link
            to="/classes"
            className={`main-nav__link ${location.pathname === "/classes" ? "active" : ""}`}
          >
            classes
          </Link>
        </li>
        <li>
          <Link
            to="/gallery"
            className={`main-nav__link ${location.pathname === "/gallery" ? "active" : ""}`}
          >
            gallery
          </Link>
        </li>
        <li>
          <Link
            to="/about"
            className={`main-nav__link ${location.pathname === "/about" ? "active" : ""}`}
          >
            about
          </Link>
        </li>
        <li>
          <Link
            to="/order"
            className={`main-nav__link ${location.pathname === "/order" ? "active" : ""}`}
            id="order-nav"
          >
            order
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default MainNav;
